import { render } from "./PassTimesForm.vue?vue&type=template&id=70b4d110"
import script from "./PassTimesForm.vue?vue&type=script&lang=js"
export * from "./PassTimesForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__